import client, { adkClient } from "../auth/client";

export const listApps = async () => {
  const response = await adkClient.get("/list-apps");
  const apps: string[] = response.data ?? [];
  return apps.filter((app) => app === "rag");
};

export const createSession = async (data: {
  userId: string;
  app_name: string;
}) => {
  const { userId, app_name } = data;
  const response = await adkClient.post(
    `/apps/${app_name}/users/${userId}/sessions`
  );
  return response.data;
};

export const getFilesFromRagCorpus = async (reqBody: {
  apiProps: {
    rag?: string;
  };
  queryParams: {
    page: number | string;
    page_size: number;
  };
}) => {
  const { page, page_size } = reqBody.queryParams;
  const { rag } = reqBody.apiProps;
  const res = await adkClient.get(
    `/corpus/${rag}/files?page_size=${page_size}${
      page ? `&page_token=${page}` : ""
    }`
  );
  return res.data;
};

export const getADKChatSessionDetails = async (reqBody: {
  apiProps: {
    search_by?: string;
    userId?: string;
    app_name?: string;
  };
  queryParams: {
    page: number;
    page_size: number;
  };
}) => {
  const { apiProps, queryParams } = reqBody;
  const { search_by, userId, app_name } = apiProps || {};
  const { page, page_size } = queryParams || {};

  if (!app_name || !userId) return { results: [], count: 0 };

  try {
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(page_size),
      ...(search_by ? { search_by } : {}),
    });

    const res = await adkClient.get(
      `/apps/${app_name}/users/${userId}/sessions?${params.toString()}`
    );

    let results = res?.data ?? [];
    return {
      results,
      count: Array.isArray(results) ? results.length : 0,
    };
  } catch (error) {
    console.error("Failed to fetch chat session details:", error);
    return { results: [], count: 0 };
  }
};

export const getADKConversationData = async (chatSessionId: string, userId : string, appName : string) => {
  const res = await adkClient.get(`/apps/${appName}/users/${userId}/sessions/${chatSessionId}`);
  return res.data;
};


export const deleteADKChatHistory = async (chatSessionId: string, apiProps: { userId: string; app_name: any; }) => {
  const res = await adkClient.delete(`/apps/${apiProps.app_name}/users/${apiProps.userId}/sessions/${chatSessionId}`);
  return res;
};

